"use strict";

exports.__esModule = true;
exports.AppRoute = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Auth = require("../Auth");
var _Core = require("../Core");
var _Theme = require("../Theme");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AppRouteWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AppRoute__AppRouteWrapper",
  componentId: "sc-xtgx5h-0"
})(["width:180px;height:180px;padding:25px;text-align:center;color:", ";background:", ";box-shadow:0 0 5px ", ";border-radius:", ";transition:box-shadow 0.3s;transition:background 0.5s;display:flex;flex-direction:column;justify-content:space-between;align-items:center;&:hover{text-decoration:none;color:", ";background:", ";box-shadow:0 0 5px ", ";}"], (0, _Theme.selectable)("ThumbnailListItemColor"), (0, _Theme.selectable)("ThumbnailListItemBackground"), (0, _Theme.selectable)("ThumbnailListItemShadow"), (0, _Theme.selectable)("ThumbnailListItemBorderRadius"), (0, _Theme.val)("SelectedThumbnailListItemColor"), (0, _Theme.val)("SelectedThumbnailListItemBackground"), (0, _Theme.val)("SelectedThumbnailListItemShadow"));
var AppLink = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "AppRoute__AppLink",
  componentId: "sc-xtgx5h-1"
})(["text-decoration:none;&:hover{text-decoration:none;}"]);
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AppRoute__IconWrapper",
  componentId: "sc-xtgx5h-2"
})(["margin-top:18px;"]);
var AppName = _styledComponents["default"].div.withConfig({
  displayName: "AppRoute__AppName",
  componentId: "sc-xtgx5h-3"
})(["font-size:18px;margin-top:10px;height:50px;color:", ";"], function (props) {
  return props.theme.color;
});
var AppRoute = exports.AppRoute = function AppRoute(props) {
  var id = props.id,
    defaultName = props.defaultName,
    icon = props.icon,
    screenPath = props.screenPath,
    permission = props.permission,
    featureFlag = props.featureFlag;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  return /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: permission,
    featureFlag: featureFlag
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: 20
    }
  }, /*#__PURE__*/_react["default"].createElement(AppLink, {
    to: screenPath
  }, /*#__PURE__*/_react["default"].createElement(AppRouteWrapper, null, /*#__PURE__*/_react["default"].createElement(IconWrapper, null, /*#__PURE__*/_react["default"].cloneElement(icon, {
    color: theme && theme.color ? theme.color : "defaultColor",
    size: 40
  })), /*#__PURE__*/_react["default"].createElement(AppName, null, translate(id, defaultName))))));
};